import React, { useEffect, useState } from "react";
import useGlobal from "../../store";
import { getBuildingVariables, getFeatureVariables, getSiteVariables, getSpaceVariables, getEquipmentVariables } from "../../services/MetadataService";
import { getAllSiteVariables, getAllSpaceVariables, getPotentialVariables } from "../../services/AirtableService";

import { useHistory } from "react-router-dom";
import VariableEntry from "../../components/VariableEntry";
import { ModeEdit } from "@mui/icons-material";
import { propStyle } from "aws-amplify-react";
import { IconButton } from "@material-ui/core";

const VariableList = (props) => {
    const [variables, setVariables] = useState()
    const [potentialVariables, setPotentialVariables] = useState()
    const [inheritedVariables, setInheritedVariables] = useState()
    const[location, setLocation] = useState('Variables')
    let [currentState, currentActions] = useGlobal();
    let history = useHistory();

    useEffect(() => {
        if (!variables) {
            if (!props) return;

            if (props.context === "site") {
                getSiteVariables(props.id).then(response => {
                    setVariables(response)
                });
            } else if (props.context == "space") {
                getSpaceVariables(props.id).then(response => {
                    setVariables(response)
                });
            } else if (props.context == "building") {
                getBuildingVariables(props.id).then(response => {
                    setVariables(response)
                });
            } else if (props.context == "feature") {
                getFeatureVariables(props.id).then(response => {
                    console.log(response)
                    setVariables(response.variables)
                });
            } else if (props.context == "equipment") {
                getEquipmentVariables(props.id).then(response => {
                    setVariables(response)
                });
            }

        }

    }, [])

    useEffect(() => {
        async function fetchPotentialVars() {
            const potentialVars = await getPotentialVariables(props.context);
            setPotentialVariables(potentialVars);
        }
        fetchPotentialVars();
    }, [props.context])



    //TODO: This needs cleanup but moving things ends up in a lot of eventing.  CLean this up later
    const getInheritedValues = () => {
        let historyMap = Object.assign({}, inheritedVariables);
        if (props.context === "building") {
            let site = currentState.site;
            if (site && site.site_id) {
                getSiteVariables(site.site_id).then (response => {
                    response.forEach(entry => {
                        if (!historyMap.name) {
                            let history = entry.variable_history;
                            if (history) {
                                history[0].from = "Site"
                                historyMap[entry.name] = history[0]
                            }
                        }
                    })

                    setInheritedVariables(historyMap)
                })
            }
        }  else if (props.context === "space" || props.context === "feature") {
            let building = currentState.building;
            if (building && building.id) {
                getBuildingVariables(building.id).then (response => {
                    response.forEach(entry => {
                        if (!historyMap.name) {
                            let history = entry.variable_history;
                            if (history) {
                                history[0].from = "Building"
                                historyMap[entry.name] = history[0]
                            }
                        }
                    })

                    let site = currentState.site;
                    if (site && site.site_id) {
                        getSiteVariables(site.site_id).then (response => {
                            response.forEach(entry => {
                                if (!historyMap.name) {
                                    let history = entry.variable_history;
                                    if (history) {
                                        history[0].from = "Site"
                                        historyMap[entry.name] = history[0]
                                    }
                                }
                            })

                            setInheritedVariables(historyMap)
                        })
                    }
                })
            }
        } else {
            setInheritedVariables(historyMap)
        }

    }

    useEffect(() => {
        getInheritedValues();
    },[currentState.building, currentState.site, currentState.space, currentState.equipment])

    if (!variables || !inheritedVariables) return null;

    let collectedVariables = {}
    let collectedVarNames = []
    if (potentialVariables) {
        potentialVariables.forEach(pv => {
            let variable = variables.find(v => v.name === pv.name)
            collectedVariables[pv.name] = variable && variable.variable_history

            collectedVarNames.push(pv.name)
        })
    }
    collectedVarNames.sort((a,b) => a.localeCompare(b))

    return <div className="layer3">
        <div className="edit-mode">
                <IconButton key="edit-vars"
                            variant="contained"
                            color="primary"
                            aria-label={"Edit Variables" }

                            onClick={() => {
                                history.push("/variables/" + props.context + "/" + props.id + "/add")
                        }}>
                            <ModeEdit style={{fill: "#888"}}/>
                </IconButton>
            </div>
            <div className="variable-list">
                {
                    collectedVarNames.map(name => {
                        let cv = collectedVariables[name]
                        return <VariableEntry key={name} name={name} variable_history={cv} inherited_history={inheritedVariables[name]} />
                    })
                }
            </div>

        </div>

}

export default VariableList;